import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { environment } from '../environments/environment';
import { Chart, registerables } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  standalone: false,
})
export class AppComponent implements OnInit {
  public title = 'Dashboard';
  public colors = environment['colors'];
  private faviconUrl = environment['logo_paths']['favicon'];
  public userLoaded = false;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    public router: Router,
  ) {
    Chart.register(...registerables, ChartDataLabels); // Enable chart.js label plugins
  }

  ngOnInit() {
    this._setGlobalStyles();
    this._updateFavicon();
  }

  private _setGlobalStyles() {
    if (isPlatformBrowser(this.platformId)) {
      const style = document.createElement('style');
      style.innerHTML = `.mat-mdc-slider .mdc-slider__track--active_fill,
                         .mat-mdc-slider .mdc-slider__thumb-knob {
                            border-color: ${this.colors['primary']} !important;
                          }
                         .mdc-checkbox__native-control:enabled:checked~.mdc-checkbox__background, .mdc-checkbox__native-control:enabled:indeterminate~.mdc-checkbox__background
                         .mat-pseudo-checkbox-full.mat-pseudo-checkbox-checked, .mat-pseudo-checkbox-full.mat-pseudo-checkbox-indeterminate {
                            background-color: ${this.colors['primary']} !important;
                         }
                         .mat-mdc-option.mdc-list-item--selected:not(.mdc-list-item--disabled) .mdc-list-item__primary-text,
                         .mdc-text-field--filled:not(.mdc-text-field--disabled).mdc-text-field--focused .mdc-floating-label, .mdc-text-field--filled:not(.mdc-text-field--disabled).mdc-text-field--focused .mdc-floating-label--float-above {
                            color: ${this.colors['primary']} !important;
                         }

                         .mat-mdc-fab.mat-accent, .mat-accent {
                                --mdc-fab-container-color: ${this.colors['refresh_btn']} !important;
                                --mat-fab-foreground-color: white;
                                --mat-fab-state-layer-color: white;
                                --mat-fab-ripple-color: rgba(255, 255, 255, 0.1);
                         }

                        .mat-mdc-fab.mat-primary, .mat-mdc-fab {
                            --mdc-fab-container-color: ${this.colors['primary']} !important;
                            --mat-fab-foreground-color: white;
                            --mat-fab-state-layer-color: white;
                            --mat-fab-ripple-color: rgba(255, 255, 255, 0.1);
                        }

                         .mdc-checkbox__native-control:enabled:checked~.mdc-checkbox__background, .mdc-checkbox__ripple {
                            background-color: ${this.colors['primary']} !important;
                            border-color: ${this.colors['primary']} !important;
                         }

                        .mdc-switch__track::after {
                            background: ${this.colors['tool_btn_inactive']} !important;
                        }

                        .mat-mdc-slide-toggle.mat-accent {
                            --mdc-switch-selected-focus-state-layer-color: ${this.colors['primary']} !important;
                            --mdc-switch-selected-handle-color: ${this.colors['primary']} !important;
                            --mdc-switch-selected-hover-state-layer-color: ${this.colors['primary']} !important;
                            --mdc-switch-selected-pressed-state-layer-color: ${this.colors['primary']} !important;
                            --mdc-switch-selected-focus-handle-color: ${this.colors['primary']} !important;
                            --mdc-switch-selected-hover-handle-color: ${this.colors['primary']} !important;
                            --mdc-switch-selected-pressed-handle-color: ${this.colors['primary']} !important;
                            --mdc-switch-selected-focus-track-color: ${this.colors['primary']} !important;
                            --mdc-switch-selected-hover-track-color: ${this.colors['primary']} !important;
                            --mdc-switch-selected-pressed-track-color: ${this.colors['primary']} !important;
                            --mdc-switch-selected-track-color: ${this.colors['primary']} !important;
                        }

                         .course-mat-chip {
                            background-color: ${this.colors['chip_bg']} !important;
                         }
                         .course-mat-chip .mat-mdc-chip-action-label,
                         .course-mat-chip .mat-mdc-chip-remove {
                            color: ${this.colors['chip_text']} !important;
                         }
                            
                         .refresh-button {
                            background-color: ${this.colors['refresh_btn']};
                         }`;
      document.head.appendChild(style);
    }
  }

  private _updateFavicon(): void {
    if (isPlatformBrowser(this.platformId)) {
      const link: HTMLLinkElement | null =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link');
      link.type = 'image/x-icon';
      link.rel = 'icon';
      link.href = this.faviconUrl;
      document.getElementsByTagName('head')[0].appendChild(link);
    }
  }
}
